import React, { useState } from "react";
import faq from "@content/faq.json";

const FAQItem = ({ item, open, onToggle, idx }) => (
    <div
        className={`panel transition-all ${open ? "border-[rgba(124,231,59,0.4)]" : ""}`}
        data-testid={`faq-item-${idx + 1}`}
    >
        <button
            className="w-full flex items-center justify-between text-left p-4 md:p-5 gap-4"
            onClick={onToggle}
            aria-expanded={open}
            data-testid={`faq-toggle-${idx + 1}`}
        >
            <span className="font-display font-semibold text-slate-900 text-base md:text-lg leading-snug">
                {item.question}
            </span>
            <span
                className={`shrink-0 w-8 h-8 rounded-full border border-[var(--border)] flex items-center justify-center text-brand transition-transform ${
                    open ? "rotate-45 border-[rgba(124,231,59,0.5)]" : ""
                }`}
                aria-hidden
            >
                <svg width="14" height="14" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M11 5h2v14h-2z M5 11h14v2H5z" />
                </svg>
            </span>
        </button>
        {open && (
            <div className="px-4 md:px-5 pb-4 md:pb-5 -mt-1 text-dim leading-relaxed" data-testid={`faq-answer-${idx + 1}`}>
                {item.answer}
            </div>
        )}
    </div>
);

const FAQ = () => {
    const [openIdx, setOpenIdx] = useState(0);

    return (
        <section className="section" id="faq" data-testid="faq-section">
            <div className="container-p">
                <div className="max-w-3xl">
                    <span className="eyebrow gray">Clear Doubts</span>
                    <h2 className="mt-4 font-display text-3xl md:text-5xl font-extrabold leading-tight text-slate-900">
                        Frequently Asked{" "}
                        <span className="text-brand">Questions.</span>
                    </h2>
                    <p className="mt-4 text-dim text-base md:text-lg">
                        Got questions about lab topologies, schedules, or refund rules? We have answered
                        everything here.
                    </p>
                </div>

                <div className="mt-6 max-w-3xl space-y-2">
                    {faq.map((item, i) => (
                        <FAQItem
                            key={i}
                            item={item}
                            idx={i}
                            open={openIdx === i}
                            onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
